import "/app/sentry.client.config.js";
import { init } from 'astro/virtual-modules/prefetch.js';init()